// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3GzGx","item":"PaymentsMobile_item__1axjU","label":"PaymentsMobile_label__2QrZA","amount":"PaymentsMobile_amount__3yu2b"};